<template>
  <div>
    <div class="order-item" :key="index" v-for="(item, index) in orderList">
      <div class="order-item-info">
        <div class="order-time" style="cursor: pointer" @click="closeOrders(index)">
          {{ item.createtime.substring(0,10) }}
          <i class="el-icon-arrow-right" v-if="item.close === false"></i>
          <i class="el-icon-arrow-down" v-if="item.close === true"></i>
        </div>
        <div class="order-main-info">
          <div class="order-store">
            {{ item.shop_name }}&nbsp;
            <span>订单号:{{ item.code }}</span>
          </div>
          <div class="order-money">
            {{ item.goods_list.length }}款商品合计 ￥{{ item.payment }}
          </div>
        </div>
      </div>
      <template v-for="(one, i) in item.goods_list">
      <div class="order-goods-info" v-if="item.close === true" :key="i" >
        <div class="goods-left" style="float: left"></div>
        <div class="goods-main-info">
          <div style="float: left">{{ one.item_name }}</div>
          <div class="goods-price">
            <span>单价￥{{ one.price }}</span>&nbsp;&nbsp;&nbsp;
            <span>x{{ one.qty }}</span>
          </div>
        </div>
      </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modelOrder',
  props: ['orderList'],
  data () {
    return {
    }
  },
  methods: {
    // 开关时间轴的日期
    closeOrders(index) {
      if (this.orderList[index].close === false) {
        this.orderList[index].close = true
      } else {
        this.orderList[index].close = false
      }
    }
  },
  created() {
  }
}
</script>

<style scoped>
.goods-price{
  float: right;
}
.order-item{
  width: 100%;
  height: auto;
  line-height: 50px;
}
.order-item-info{
  width: 100%;
  height: 50px;
  color: #666;
}
.order-time{
  width: 25%;
  float: left;
  height: 50px;
  font-size: 14px;
}
.order-main-info{
  width: 71%;
  float: left;
  height: 50px;
  padding: 0 2%;
}
.goods-main-info {
  float: right;
  width: 69%;
  height: 50px;
  padding: 0 2%;
  background: #ECF0F7;
  margin-right: 2%;
}
.order-store{
  float: left;
  font-size: 14px;
}
.order-money{
  float: right;
}
.order-goods-info{
  width: 100%;
  height: 50px;
  margin-bottom: 10px;
  color: #999;
  font-size: 14px;
}
::-webkit-scrollbar
{
  width: 6px;  /*滚动条宽度*/
  height: 16px;  /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;  /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5;/*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
  border-radius: 10px;  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #ccc;  /*滚动条的背景颜色*/
}
.day-title-content{
  width: 90%;
  margin: 0 auto;
}
.day-item{
  height: auto;
}
.day-title{
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #000;
  float: left;
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.day-title i{
  color: #000;
}
.day-line{
  width: 2px;
  height: 40px;
  background: #E7E7E7;
  position: absolute;
  bottom: -80%;
  left: 13px;
  margin-left: -7px;
  margin-bottom: -7px;
}
.total-event{
  /*width: calc(100% - 220px);*/
  height: auto;
  background: #F0F3F6;
  float: left;
  margin-left: 30px;
  margin-top: 12px;
  display: flex;
  /*justify-content: space-between;*/
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  box-sizing: content-box;
}
.total-event div {
  width: 185px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #666;
  text-align: left;
  padding-left: 20px;
}
.day-item-small{
  width: calc(100% - 161px);
  height: auto;
  float: left;
  margin-left: 39px;
  padding-bottom: 10px;
  position: relative;
  border-left: 2px solid #E7E7E7;
  box-sizing: content-box;
}
.day-item-smalls{
  width: calc(100% - 161px);
  height: auto;
  float: left;
  margin-left: 39px;
  padding-bottom: 30px;
  position: relative;
  border-left: 2px solid #E7E7E7;
}
.time-line-circle{
  width: 12px;
  height: 12px;
  background: #E7E7E7;
  position: absolute;
  left: -7px;
  top: 8px;
  border-radius: 50%;
}
.time-item{
  width: 90%;
  margin: 0 auto 0px;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.clearfloat{
  clear: both;
}
.real-time{
  font-size: 14px;
  color: #808491;
  width: 120px;
  float: left;
  height: 30px;
  margin-top: 0px;
  line-height: 30px;
  text-align: right;
}
.type-show {
  width: 80px;
  float: left;
  margin-top: -20px;
}
.type-one{
  /*height: 80px;*/
}
.type-two{
  height: 80px;
}
.type-spe p:first-child{
  margin-top: 20px;
}
.type-spe .arrow-left{
  top: 10px;
}
.arrow-left-close{
  display: block;
  position: absolute;
  height: 0px;
  width: 0px;
  border-top: 0px solid transparent;
  border-right: 10px solid #F5F5F5;
  border-bottom: 16px solid transparent;
  left: -10px;
  top: 0px;
}
.type-img .type-show-line img{
  top: 0;
}
.type-show-line{
  width: 2px;
  height: 100%;
  background: #E7E7E7;
  position: relative;
  margin: 0 auto;
}
.small-line {
  width: 2px;
  height: auto;
  background: #E5E5E5;
  position: absolute;
  /*bottom: -20px;*/
  left: 50%;
  margin-left: -1px;
  /*z-index: 200;*/
}
.small-line-one {
  width: 2px;
  height: 40px;
  background: #E5E5E5;
  position: absolute;
  left: 50%;
  margin-left: -1px;
}
.type-show-line img{
  position: absolute;
  display: block;
  top:20px;
  left: 50%;
  width: 40px;
  margin-left: -20px;
  z-index: 20;
  background:#fff;
}
.things-content{
  width: calc(100% - 200px);
  float: left;
  background: #F0F3F6;
  display: flex;
  justify-content: space-between;
  position: relative;
  height: auto;
  margin-bottom: 10px;
  margin-top: 10px;
}
.arrow-left{
  position: absolute;
  height: 0px;
  width: 0px;
  border-top: 0px solid transparent;
  border-right: 10px solid #F5F5F5;
  border-bottom: 16px solid transparent;
  left: -10px;
  top: 0px;
}

.content-title{
  font-size: 14px;
  color: #333;
  text-align: left;
  margin-left: 20px;
  line-height: 20px;
  margin-top: 18px;
  margin-bottom: 5px;
}
.content-content{
  font-size: 12px;
  color: #666;
  text-align: left;
  margin-left: 20px;
  line-height: 20px;
  margin-top: 6px;
}
.score-content{
  font-size: 14px;
  color: #333;
  text-align: center;
  margin: 10px 12px 0 0;
}
.system-event{
  padding: 0 10px;
  font-size: 14px;
  color: #059BAA;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin: 10px 10px 0 0;
  border-radius: 3px;
}
.adress-content-item {
  margin-bottom: 0px;
  text-align: left;
  margin-left: 20px;
  color: #333;
  height: 30px;
}
.adress-item {
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  color: #333;
  padding-bottom: 10px;
  padding-top: 10px;
  background-color: #f5f7fa;
  border-radius: 5px;
}
.adress-item .el-form-item {
  margin-bottom: 0px;
}
.indynamic-group .el-input__inner {
  width: auto!important;
}
.tag-content {
  margin-left: 15px;
  margin-right: 15px;
  max-width: 230px;
}
.tag-span-look {
  display: inline-block;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
  height: 20px;
  line-height: 20px;
  padding: 5px;
  margin: 5px;
  color: #999;
  font-size: 12px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
.tags-content-look {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.name-wrapper{
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
  width: 120px;
}
.event-things-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.event-img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0;
  margin-top: 7px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 5px;
}
.event-content {
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
  width: 175px;
}
.event-content-one {
  font-size: 13px;
  margin-left: 20px;
  color: #666;
}
.time-line {
  padding-bottom: 20px;
  height: 990px;
  overflow-y: auto;
}
</style>
